import { render, staticRenderFns } from "./DrugList.vue?vue&type=template&id=77bb86a2&scoped=true"
import script from "./DrugList.vue?vue&type=script&lang=js"
export * from "./DrugList.vue?vue&type=script&lang=js"
import style0 from "./DrugList.vue?vue&type=style&index=0&id=77bb86a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bb86a2",
  null
  
)

export default component.exports